import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useCallback } from "react";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import { ChevronLeftIcon, ChevronRightIcon } from "@gemini/icons";
import { useSwiper } from "swiper/react";
import { useCustomerAction } from "@/hooks";
import { InteractionEnum } from "@/types";
import { useI18n } from "@/shared/hooks";
export const SliderButtons = () => {
    const swiper = useSwiper();
    const { customerActionExposeInteraction } = useCustomerAction();
    const { t } = useI18n();
    const [isFirst, setIsFirst] = useState(swiper.isBeginning);
    const [isLast, setIsLast] = useState(swiper.isEnd);
    const commonButtonStyle = {
        position: "absolute",
        top: "50%",
        zIndex: "zIndex.1",
    };
    const handleTracking = useCallback((index) => {
        customerActionExposeInteraction([
            { key: "interaction", value: InteractionEnum.IMAGE_SLIDE },
            { key: "index", value: index },
        ]);
    }, [customerActionExposeInteraction]);
    const onNextButtonClick = useCallback(() => {
        swiper.slideNext();
        handleTracking(swiper.activeIndex);
    }, [handleTracking, swiper]);
    const onPrevButtonClick = useCallback(() => {
        swiper.slidePrev();
        handleTracking(swiper.activeIndex);
    }, [handleTracking, swiper]);
    useEffect(() => {
        if (!swiper)
            return;
        const updateEdgeState = () => {
            setIsFirst(swiper.isBeginning);
            setIsLast(swiper.isEnd);
        };
        updateEdgeState();
        swiper.on("slideChange", updateEdgeState);
        return () => {
            swiper.off("slideChange", updateEdgeState);
        };
    }, [swiper]);
    return (_jsxs(Box, { children: [!isFirst && (_jsx(Button, Object.assign({}, commonButtonStyle, { left: "spacing.16", variant: "secondary-floating", iconOnly: true, icon: ChevronLeftIcon, size: "40", type: "button", onPress: onPrevButtonClick, isDisabled: isFirst, "aria-disabled": isFirst, "data-testid": "slider-prev", children: t("gallery.slider.buttons.label.previous") }))), !isLast && (_jsx(Button, Object.assign({}, commonButtonStyle, { right: "spacing.16", variant: "secondary-floating", iconOnly: true, icon: ChevronRightIcon, size: "40", type: "button", onPress: onNextButtonClick, isDisabled: isLast, "aria-disabled": isLast, "data-testid": "slider-next", children: t("gallery.slider.buttons.label.next") })))] }));
};
